export default __webpack_public_path__ + "static/media/loading-image.2a288a5b.gif";